module.exports = __webpack_public_path__ + "common/sidebar/icon-np-credit-90cd1d7f09060d5bad4b2d3493718f3a.svg";